/**
 * Conditionally merges multiple sets of props based on boolean flags.
 * Similar in spirit to `clsx`, but for JSX props.
 *
 * Helps avoiding ternary expressions just to satisfy types such as:
 *   <MyComponent stringProp={booleanConditional ? 'String Value' : ''} />
 *
 * W/out the ternary above: <MyComponent stringProp={booleanConditional && 'String Value'} />
 * The expression would throw an Incompatible Type (boolean | string) error
 *
 * Example:
 *   <MyComponent
 *     {...spreadIf<MyComponentProps>(
 *       [isAdmin, { role: 'admin' }],
 *       [hasName, { name: 'Brandon' }],
 *       [canClick, { onClick: handleClick }]
 *     )}
 *   />
 *
 * @param condition - A boolean that determines if the props should be included.
 * @param entries - The props to conditionally include.
 * @returns The props if the condition is true, otherwise an empty object.
 */
/* eslint-disable  @typescript-eslint/no-explicit-any */
const spreadIf = (...entries) => {
    return Object.assign({}, ...entries.filter(([cond]) => cond).map(([, props]) => props));
};
export default spreadIf;
//# sourceMappingURL=spreadIf.js.map